import { FC } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import type { ModalProps } from 'antd';

import { CustomModal } from 'components/molecules/PricingSimulator/Modals/CreateEditProjectContainer';
import { colorConstants } from 'config/colorConstants';
import {
    PPA_SIM_CUSTOM_LENS_DELETE_CANCEL_BTN,
    PPA_SIM_CUSTOM_LENS_DELETE_CONFIRM_BTN,
    PPA_SIM_CUSTOM_LENS_DELETE_MODAL,
} from 'constants/ppaTestIds';

import type { DeleteCustomLensModalProps } from './customLens.types';
import { CUSTOM_LENS_UI } from './customLens.ui';

const buttonStyle = { borderRadius: CUSTOM_LENS_UI.BUTTON_BORDER_RADIUS };

const DeleteModal = styled(CustomModal)`
    .ant-modal-header {
        padding-bottom: 8px !important;
    }
    .ant-modal-footer {
        padding: 20px 24px !important;
    }
    .ant-modal-footer .ant-btn-default {
        font-weight: 500 !important;
    }
    .ant-modal-footer .ant-btn-primary {
        background-color: ${colorConstants.redAlt} !important;
        border-color: ${colorConstants.redAlt} !important;
        color: #fff !important;
    }
`;

const DeleteCustomLensModal: FC<DeleteCustomLensModalProps> = ({
    open,
    lensName,
    confirmLoading = false,
    onCancel,
    onDelete,
}) => (
    <DeleteModal
        open={open}
        width={400}
        centered
        zIndex={CUSTOM_LENS_UI.DELETE_LENS_MODAL_Z_INDEX}
        className="delete-custom-lens-modal"
        maskClosable={false}
        bodyStyle={{ padding: 0 }}
        title={
            <span className="flex items-center gap-4">
                <ExclamationCircleOutlined style={{ color: colorConstants.redAlt1 }} />
                <span className="text-sm font-medium text-blackTransparent88">Delete Lens</span>
            </span>
        }
        okText="Delete"
        cancelText="Cancel"
        confirmLoading={confirmLoading}
        onCancel={onCancel}
        onOk={onDelete}
        okButtonProps={
            {
                style: buttonStyle,
                disabled: confirmLoading,
                'data-testid': PPA_SIM_CUSTOM_LENS_DELETE_CONFIRM_BTN,
            } as ModalProps['okButtonProps']
        }
        cancelButtonProps={
            {
                style: buttonStyle,
                disabled: confirmLoading,
                'data-testid': PPA_SIM_CUSTOM_LENS_DELETE_CANCEL_BTN,
            } as ModalProps['cancelButtonProps']
        }
        modalRender={(modalNode) => <div data-testid={PPA_SIM_CUSTOM_LENS_DELETE_MODAL}>{modalNode}</div>}
    >
        <p className="m-0 px-14 text-sm text-blackTransparent88">
            This operation will delete the lens across all scenarios and views where it is being used. Are you sure you
            want to delete {lensName || 'this lens'}?
        </p>
    </DeleteModal>
);

export default DeleteCustomLensModal;
